import { client } from 'repositories/client';
import { getRequestPath } from 'utils/string';
import { paths } from 'repositories/saml/paths';
import { SettingResponse } from 'repositories/saml/responseType';
import {
  AuthorizationTokenResponse,
  IphoneRegistrationTokenResponse,
} from 'repositories/saml/responseType';

const setting = async (name: string): Promise<SettingResponse> => {
  const response = await client.get<SettingResponse>(
    getRequestPath(paths.setting, { name })
  );
  return response.data;
};

const authorizationToken = async (onetimeToken: string): Promise<string> => {
  const params = new FormData();
  params.append('onetime_token', onetimeToken);
  const response = await client.post<AuthorizationTokenResponse>(
    paths.authorizationToken,
    params
  );
  return response.data.results.authorization_token;
};

const iphoneRegistrationToken = async (
  onetimeToken: string
): Promise<string> => {
  const params = new FormData();
  params.append('onetime_token', onetimeToken);
  const response = await client.post<IphoneRegistrationTokenResponse>(
    paths.iphoneRegistrationToken,
    params
  );
  return response.data.results.iphone_registration_token;
};

export const saml = {
  setting,
  authorizationToken,
  iphoneRegistrationToken,
};
